import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { RootDialog, RootDialogTitle } from '../../../components/RootDialog';
import { FilePdfIcon } from '../../../components/SvgIcons/FilePdfIcon';
import { exportFileTypes } from '../models/exportFileTypes';

interface ExportOptionsDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (file_type: exportFileTypes) => void;
  titles?: {
    title: string;
    subTitle: string;
  };
  exportFileTypes?: ExportFileTypes;
}

export type ExportFileTypes = Array<{ label: string; value: string; icon: ReactNode }>;

export const ExportOptionsDialog: FC<ExportOptionsDialogProps> = ({
  open,
  onClose,
  onSubmit,
  titles = {
    title: 'Export Resultat as',
    subTitle: 'Report',
  },
  exportFileTypes = [
    { label: 'PDF', value: 'pdf', icon: <FilePdfIcon width={'3rem'} height={'3rem'} /> },
  ],
}) => {
  const handleExport = (fileType: exportFileTypes) => {
    onSubmit(fileType);
    onClose();
  };

  return (
    <RootDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: '25rem',
        },
      }}
    >
      <RootDialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
        onClose={onClose}
        titles={{
          title: titles.title,
          subTitle: titles.subTitle,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Stack direction="row" gap={2} justifyContent="flex-start">
          {exportFileTypes.map(item => (
            <Box
              key={item.value}
              sx={{
                width: '7rem',
                height: '8rem',
                transition: 'all 0.2s ease-in-out',
                padding: '1.5rem 1rem 1rem',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'colors.gray.o10',
                },
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => handleExport(item.value as exportFileTypes)}
            >
              <Box>{item.icon}</Box>
              <Typography variant="inter16" fontWeight="semibold" textAlign="center">
                {item.label}
              </Typography>
            </Box>
          ))}
        </Stack>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1,
          }}
        >
          <ErrorOutlineIcon sx={{ width: '1rem', height: '1rem', color: 'colors.gray.o80' }} />
          <Typography variant="inter12" textAlign="left" color="colors.gray.o80">
            Select your preferred export format. Each option will generate a file with the current
            report data.
          </Typography>
        </Box>
      </Box>
    </RootDialog>
  );
};
